import React, { useState } from "react";
import "../../../components/UserComponent/UserComponent.css";
import { Container, Row, Image, Col, Modal, Button } from "react-bootstrap";
import { FaPencilAlt, FaFileAlt } from "react-icons/fa";
import { ICONS } from "../../../constants/constants";

const UserComponent = ({ user, userDetails, onEdit, documents }) => {
  const [showModal, setShowModal] = useState(false); // State to control modal visibility
  const [selectedDocument, setSelectedDocument] = useState(null); // State to store selected document
  const [isEditing, setIsEditing] = useState(false); // State to toggle edit mode
  const getDocumentIcon = (fileName) => {
    const fileExtension = fileName.trim().split(".").pop().toLowerCase();

    switch (fileExtension) {
      case "pdf":
        //alert("PDF Icon Selected");
        return ICONS.pdfIcon; // Ensure this path is correct
      case "docx":
      case "doc":
        return ICONS.wordIcon;
      case "jpg":
      case "jpeg":
      case "png":
      case "svg":
        return ICONS.imageIcon;
      default:
        return ICONS.documentIcon;
    }
  };

  // Handle document click to show modal
  const handleDocumentClick = (doc) => {
    setSelectedDocument(doc);
    setShowModal(true); // Show the modal
  };

  // Close the modal
  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedDocument(null); // Clear selected document
  };

  // Convert to d/m/y format
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

  return (
    <>
      <div className="user-container">
        <div className="profile-card p-3">
          <FaPencilAlt className="edit-icon" onClick={onEdit} />
          <Row className="align-items-center">
            {/* Left side - Profile Image */}
            <Col xs={1} className="text-center farmer-image">
              {user?.profileImage ? (
                <Image
                  src={user.profileImage}
                  roundedCircle
                  width={70}
                  height={70}
                  alt="User profile"
                />
              ) : (
                <div className="user-icon">{user?.name?.charAt(0)}</div>
              )}
            </Col>

            {/* Center - Name and Email */}
            <Col xs={8} className="text-start ps-2">
              <h2 className="username m-0">{user.name}</h2>
              <h6 className="user-email m-0">{user.email}</h6>
            </Col>
          </Row>
          <p className="joined-date">Joined on {formatDate(user.joinedDate)}</p>
        </div>

        {/* User Details */}
        <Row className="user py-3">
          {userDetails.map((detail, index) => (
            <Col key={index} className="" style={{ flex: "1 0 20%" }}>
              {" "}
              {/* Responsive columns */}
              <h6>{detail.label}</h6>
              <p>{detail.value}</p>
            </Col>
          ))}
        </Row>

        {/* Conditionally Render Documents Row */}
      </div>
    </>
  );
};

export default UserComponent;
